import { render, staticRenderFns } from "./wordpressProposals.vue?vue&type=template&id=0e520ed9&scoped=true&"
import script from "./wordpressProposals.vue?vue&type=script&lang=js&"
export * from "./wordpressProposals.vue?vue&type=script&lang=js&"
import style0 from "./wordpressProposals.vue?vue&type=style&index=0&lang=css&"
import style1 from "./wordpressProposals.vue?vue&type=style&index=1&id=0e520ed9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e520ed9",
  null
  
)

export default component.exports